import thunk from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
	SidebarReducer,
	PlayerReducer,
	MarkerReducer,
	FilterReducer,
	UserReducer
} from 'Reducers';

const reducers = {
	sidebar: SidebarReducer,
	player: PlayerReducer,
	marker: MarkerReducer,
	fltr: FilterReducer,
	user: UserReducer
};
const rootReducer = combineReducers(reducers);

const middleware = [thunk];
const initialState = {};
const devToolsCompose = composeWithDevTools(applyMiddleware(...middleware));
export const store = createStore(rootReducer, initialState, devToolsCompose);
